import axiosInstance from "../../utils/axios"

export const getSummaryData = async (value) => {
    let res = await axiosInstance.post(`progress/test`, value)
    return res
}
export const getInstallStatsReport = async (data) => {
    let res = await axiosInstance.get(
        `/progress/installed_stats/activity?activity_id=${data?.actId}&start_date=${data?.startDate}&end_date=${data?.endDate}`
    );
    return res
}
export const getInstallStatsDownloadReport = async () => {
    let res = await axiosInstance.get('/progress/installed_stats_download?activity_id=all');
    return res
}
export const getSummarizedInventoryData = async(filter)=>{
    let result =  await axiosInstance.post(`/laydown-scope/v2/report/summarized_inventory_table`, {laydown_ids : filter});
    return result?.data
}

export const getTrackerData = async (block = 'all') => {
    try {
        let res = await axiosInstance.get(`/tracker_row/get_count_tracker_type_wise_row_for_block?block=${block}`);
        return res;
    } catch (error) {
        console.error('Error in getTrackerData:', error);
        throw error;
    }
}

export const getBlockNames = async () => {
    try {
        const response = await axiosInstance.get('/tracker_row/block_id_names');
        return response;
    } catch (error) {
        console.error('Error fetching block names:', error);
        throw error;
    }
}

export const getPartDetails = async () => {
    let res = await axiosInstance.get(`/projects/activitymilestone`)
    return res
}

export const getBomRequiredBlockWise = async () => {
    let res = await axiosInstance.get(`/bom/v2/get_bom_required_block_wise`)
    return res
}

export async function getScopeData(value) {
  let responseData = await axiosInstance.post(`/laydown-scope/v2/filtered`, value)
  return responseData
}